import {FieldError} from 'react-hook-form';

export function usePrompts() {
  const responseFeedbacks = {
    createGenerativePrompt: {
      title: 'Criar prompt generativo',
      error: {
        message: 'Ocorreu um erro ao criar o prompt generativo.',
      },
      success: {
        message: 'O prompt generativo foi criado.',
      },
    },
    default: {
      title: 'Requisição',
      error: {
        message: 'Erro',
      },
      success: {
        message: 'Sucesso',
      },
    },
  };

  function getFormFieldError(
    errorType: FieldError['type'] | undefined,
  ): string | undefined {
    if (errorType === 'required') {
      return 'Esse campo não pode ficar em branco';
    }

    return;
  }

  return {
    responseFeedbacks,
    getFormFieldError,
  };
}
